'use client'
import ThreeDotsLoader from '@/shared/v2/shared/components/ThreeDotsLoader'
import { ReactNode } from 'react'
import '../../../../assets/styles/global.css'
import ErrorBoundary from '../../../../shared/components/common/AsyncWrapper/ErrorBoundary'
import { useCompany } from '../../../../shared/hooks/useCompanies'
import { useMe } from '../../../../shared/hooks/useMe'
import Sidebar from '../../../components/Sidebar/Sidebar'
import SandboxBanner from '../components/SandboxBanner'
import { ToastProvider } from '../components/Toaster/ToasterProvider'

type RootLayoutProps = {
    children: ReactNode
}

const RootLayout = ({ children }: RootLayoutProps) => {
    const { isGod, isLoading } = useMe()
    const company = useCompany()

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen w-screen">
                <ThreeDotsLoader />
            </div>
        )
    }

    const isSandbox = String(process.env.NEXT_PUBLIC_SANDBOX) === 'true'
    const layoutHeight = isSandbox ? `h-[calc(100vh-35px)]` : 'min-h-screen max-h-screen'
    return (
        <>
            <div className="flex flex-col h-screen">
                {isSandbox && <SandboxBanner />}
                <div className={`flex bg-backgroundSecondary flex-grow ${layoutHeight}`}>
                    <div className="flex-grow bg-backgroundSecondary" />
                    <div className="flex w-full max-w-[1650px]">
                        <aside className="min-w-[250px] w-[250px] bg-backgroundSecondary overflow-y-auto">
                            <Sidebar company={company.data} isLoading={company.isLoading} isGod={isGod} />
                        </aside>
                        <main className="flex-grow bg-backgroundPrimary py-6 px-8 overflow-y-auto">
                            <ErrorBoundary>
                                <ToastProvider>
                                    <div className="h-full">{children}</div>
                                </ToastProvider>
                            </ErrorBoundary>
                        </main>
                    </div>
                    <div className="flex-grow bg-backgroundPrimary" />
                </div>
            </div>
        </>
    )
}

export default RootLayout
